import { useMemo } from 'react';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useDynamicReport } from '../../scheduled-reports/hooks/useDynamicReport';
import {
    META_MODEL_TYPE_PERFORMANCE,
    useDynamicReportMetaModel,
} from '../../scheduled-reports/hooks/useDynamicReportMetaModel';
import { useReportStorageReady } from '../../taboola-common-frontend-modules/storage/useReportStorageReady';
import { isStaticReport } from '../config/isStaticDynamicReport';
import { transformDynamicReportToConfig } from '../modules/campaigns-reports/services/dynamicReportsService';

export const useReportConfig = (reportConfigMap, selectedReport) => {
    const { formatMessage } = useIntl();
    const { dynamicReport, isSuccess } = useDynamicReport(selectedReport);
    const [reportStorageReady] = useReportStorageReady();
    const { metaModel, isSuccess: metaModelSuccess } = useDynamicReportMetaModel(META_MODEL_TYPE_PERFORMANCE);
    const reportConfig = useMemo(() => {
        if (isStaticReport(selectedReport)) {
            return { ready: true, ...(reportConfigMap[selectedReport] || {}) };
        }

        return {
            ready: isSuccess && metaModelSuccess && reportStorageReady,
            ...(isSuccess && metaModelSuccess
                ? transformDynamicReportToConfig(dynamicReport, metaModel, formatMessage)
                : {}),
            dynamicReport: dynamicReport ?? {},
        };
    }, [
        reportConfigMap,
        selectedReport,
        dynamicReport,
        isSuccess,
        metaModelSuccess,
        metaModel,
        formatMessage,
        reportStorageReady,
    ]);

    return reportConfig;
};
